// Modules
import cn from 'classnames';

// Types
import type { TTooltipDialogueProps } from './Tooltip.type';

// Styles
import styles from './styles.module.scss';

// Helpers
import { snakeCase } from '../../helpers/typography';

// Constants
import { TOOLTIP_DEFAULT_PROPS } from './Tooltip.constant';

const TooltipDialogue = (props: TTooltipDialogueProps) => {
	const {
		className,
		children,
		dialogueContentClassName,
		noArrow,
		position = TOOLTIP_DEFAULT_PROPS.position,
		...restProps
	} = props;

	const tooltipDialogueCN = cn(styles.legion_tooltip, className, styles[snakeCase(position!)], {
		[styles.no_arrow]: !!noArrow
	});
	const tooltipDialogueContentCN = cn(styles.tooltip_dialogue, dialogueContentClassName);

	return (
		<div className={tooltipDialogueCN} {...restProps}>
			<div className={tooltipDialogueContentCN}>
				{children}
			</div>
		</div>
	)
}

export default TooltipDialogue;
